/* eslint-disable react/prop-types */
import React, { useState, useCallback } from 'react';
import DownloadZipModal, { triggerDownload } from '../DownloadZipModal/DownloadZipModal';
import { ToastList } from '../Dialog/Dialog';

import './DownloadZipPdfs.scss';

const CHUNK_THRESHOLD = 20;

const DownloadZipPdfs = ({ data }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [toasts, setToasts] = useState([]);

    const addToast = useCallback((success, message) => {
        setToasts((prev) => [...prev, { id: Date.now(), success, message }]);
    }, []);

    const dismissToast = useCallback((id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    }, []);

    const ids = data.map((item) => item.id);

    const handleClick = async () => {
        if (ids.length <= CHUNK_THRESHOLD) {
            try {
                await triggerDownload(ids);
                addToast(true, 'Descarga completada correctamente');
            } catch {
                addToast(false, 'Error al realizar la descarga');
            }
        } else {
            setIsOpen(true);
        }
    };

    return (
        <>
            <ToastList toasts={toasts} onDismiss={dismissToast} />
            <button className="icon-button" type="button" onClick={handleClick}>
                <i className="fas fa-file-pdf" />
            </button>
            <DownloadZipModal
                isOpen={isOpen}
                toggle={() => setIsOpen(false)}
                ids={ids}
            />
        </>
    );
};

export default DownloadZipPdfs;
